import { Stores } from "../modules";

export const StoresPage = () => {
  return <Stores />;
};
